<template>
  <div class="login">
    <svg width="69" height="59" viewBox="0 0 69 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M55.4984 29.8944C55.2112 29.8944 54.9393 29.7532 54.7727 29.5144L49.3802 21.6899L39.8804 21.6967C39.5448 21.6967 39.2386 21.5075 39.0909 21.2066C38.9429 20.9053 38.9776 20.5475 39.1805 20.2812L44.9546 12.7334L42.0131 3.69792C41.9098 3.37965 41.9957 3.03071 42.2354 2.79675C42.4762 2.56278 42.832 2.48574 43.1434 2.59546L52.1031 5.75843L59.7868 0.168265C60.0567 -0.0293954 60.4165 -0.0535986 60.7138 0.0992859C61.0111 0.257818 61.1934 0.567217 61.1854 0.902837L60.9478 10.4027L68.6364 15.9823C68.9066 16.1784 69.0442 16.512 68.9873 16.8424C68.9304 17.1727 68.6916 17.4426 68.3701 17.5394L59.2656 20.2482L56.3362 29.2853C56.233 29.6036 55.9579 29.8355 55.6259 29.8855C55.5827 29.8908 55.5395 29.8944 55.4984 29.8944ZM49.8429 19.9283C50.1321 19.9283 50.4036 20.0711 50.5686 20.3083L55.2112 27.0441L57.7328 19.2643C57.8223 18.9888 58.041 18.7742 58.3193 18.6915L66.1575 16.3591L59.5371 11.5551C59.3036 11.3849 59.1676 11.1114 59.1745 10.821L59.3794 2.64185L52.765 7.45468C52.5347 7.62653 52.2285 7.66969 51.955 7.57328L44.2406 4.8504L46.7723 12.6286C46.8618 12.9037 46.8102 13.2046 46.6343 13.4349L41.6642 19.9335L49.8429 19.9283Z" fill="#17A6FF"/>
      <path d="M21.9248 45.378C21.9544 45.434 21.9768 45.4942 21.9908 45.5574C22.0467 45.809 21.9655 46.0725 21.7751 46.2479L9.18559 57.8547C8.99535 58.0303 8.72663 58.0905 8.4798 58.0131C8.23156 57.9364 8.04342 57.732 7.98928 57.4808L4.23195 40.773C4.17609 40.5213 4.25727 40.2578 4.44765 40.0824C4.63789 39.9068 4.90634 39.8467 5.15345 39.924L21.5004 45.0254C21.6856 45.0824 21.837 45.2116 21.9248 45.378ZM9.12634 55.941L19.8734 46.0326L5.91834 41.679L9.12634 55.941Z" fill="#FF82FF"/>
    </svg>


    <h1>Inicia sesión</h1>
    <form ref="form" @keydown.enter="onKeyEnter">
      <label for="email">Correo electrónico:</label>
      <input class="round" v-model="MEmail" type="text" placeholder="micuenta@feliz.com" required>
      <button class="round interactive" @click="onKeyEnter" :disabled="(mailError || loading)"> 
        {{loading?'':'Siguiente'}}
        <b-icon v-if="loading" size='small' class="spin" icon="spinner" ></b-icon>
        
      </button>
    </form>
    <div>
      <p>¿Aún no tienes cuenta? <router-link to="/register">Haz click aquí</router-link> </p>
    </div>

    <svg style="margin-left: auto;" width="83" height="60" viewBox="0 0 83 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M63.4304 12.2165L70.6446 7.01172L70.4211 15.8553L77.6425 21.0507L69.0939 23.5755L66.3416 31.9899L61.2775 24.7056L52.3574 24.7115L57.7784 17.6865L55.0187 9.27519L63.4304 12.2165Z" fill="#FDD047"/>
      <path d="M7.50164 60L0 52.5L7.50164 45L15.0014 52.5L7.50164 60ZM2.3641 52.5L7.50164 57.6359L12.6375 52.5L7.50164 47.3641L2.3641 52.5Z" fill="#17A6FF"/>
    </svg>


    <Watermark class="bottom"/>
  </div>
</template>

<script>

import Watermark from '@/components/Watermark.vue'
import JWT from "@/js/jwtDecode.js"
import API from "@/js/api"

import { SnackbarProgrammatic as Snackbar } from 'buefy'
export default {
    components:{
      Watermark
    },
    data(){
      return{
        MEmail: "",
        mailError : "",
        loading:false
      }
    },
    methods:{
      onKeyEnter(event){
        console.log('holas');
        this.login(this.MEmail)
        event.preventDefault()
      },
      login(mail) {
        if(this.$refs.form.checkValidity() && !this.loading){
        this.loading = true;
        API.session.login({
          'email': mail
        }).then( () =>{
          this.loading = false;
          this.$router.push("/sent")
        },(response)=>{
          this.loading = false;
          Snackbar.open(response.statusText)
        })
        }
        else if(!this.$refs.form.checkValidity()){
           Snackbar.open("Correo invalido")
        }
      },
    },
    watch: {
      MEmail: function(){
        if(this.$refs.form)
          this.mailError = !this.$refs.form.checkValidity()
      },
    },
    created() {
      var resp = window.localStorage.getItem('mr-jwt')
      if (resp) {
        var decoded = JWT.decode(resp);
        if (decoded.approved)
          this.$router.push("/dashboard")
      }
    }
  }
</script>

<style scoped lang="scss">
  .login {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding:20px;
    justify-content: center;
  }
  h1{
    font-family: Montserrat;
    font-size: 40px;
    font-weight: bold;
    line-height: 49px;
    letter-spacing: 0em;
    color: #17A6FF;
  }
  a{
    color:#F75353;
    font-weight: bold;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .spin{
    animation: spin 2s linear infinite;
  }
  p{
    color:#9C9C9C;
  }
  label{
    color:#9C9C9C;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0em;
  }
  .round{
    width:100%;
    max-width: 400px;
    height:60px;
    border-radius: 1000px;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0em;
  }
  label{
    margin-top:10px;
  }
  input{
    border:solid 1px #EAEAEA;
    padding-left:20px;
    margin: 0px auto;
  }
  
  input:invalid{
    border:solid 1px #F75353;
  }
  button{
    background: #59E9DD;
    color:white;
    border:none;
    margin: 40px auto;
  }

  
  .bottom{
    position: absolute;
    bottom:40px;
    left:0;
    right:0;
  }


</style>